import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { BYPASS_AUTH } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class DiscursoService extends ApiConfig {

  constructor(private http: HttpClient) {
    super();
  }

  listarRecente() {
    try {
      return new Promise(async (resolve) => {

        this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Discurso/listarRecentes',
          {})
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }
  listarPorProjeto(idProjetoLista, processId = "") {
    try {
      return new Promise(async (resolve) => {
        this.http.post(`https://project-5082f113-c983-477a-973.uw.r.appspot.com/Discurso/ListarPorProjetoLei?processId=${processId}`,
          idProjetoLista)
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Discurso/Obter?Id='+id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  listarPorTag(tag, processId) {
    try {
      return new Promise(async (resolve) => {

        this.http.get(`https://project-5082f113-c983-477a-973.uw.r.appspot.com/Discurso/ListarPorTag2?tag=${tag}&processId=${processId}` + tag, { context: new HttpContext().set(BYPASS_AUTH, true) })
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }
  listarPorAutor(tag) {
    try {
      return new Promise(async (resolve) => {

        this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Discurso/listarPorAutor?nome=' + tag, { context: new HttpContext().set(BYPASS_AUTH, true) })
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }
}

